import React from 'react';

const SvgHomeWhite = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="currentColor" // Use "currentColor" for inheriting text color
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread props for additional customization
  >
    <g clipPath="url(#clip0_328_1966)">
      <path
        d="M15 7.88226L4.30063 16.7028C4.30063 16.7152 4.2975 16.7335 4.29125 16.7585C4.28512 16.7833 4.28186 16.8012 4.28186 16.814V25.7457C4.28186 26.0682 4.39976 26.3477 4.6355 26.583C4.87117 26.8185 5.15025 26.937 5.47281 26.937H12.618V19.7914H17.3821V26.9372H24.5272C24.8496 26.9372 25.1291 26.819 25.3645 26.583C25.6002 26.3479 25.7185 26.0683 25.7185 25.7457V16.814C25.7185 16.7645 25.7117 16.7271 25.6997 16.7028L15 7.88226Z"
        fill="currentColor"
      />
      <path
        d="M29.793 14.693L25.7182 11.3064V3.71429C25.7182 3.54073 25.6624 3.398 25.5504 3.28629C25.4393 3.17471 25.2966 3.11892 25.1227 3.11892H21.55C21.3763 3.11892 21.2336 3.17471 21.1218 3.28629C21.0103 3.398 20.9546 3.5408 20.9546 3.71429V7.3428L16.4143 3.54666C16.0178 3.22411 15.5463 3.06287 15.0004 3.06287C14.4546 3.06287 13.9832 3.22411 13.5863 3.54666L0.206772 14.693C0.0827436 14.7921 0.0147659 14.9254 0.00212194 15.0929C-0.0104569 15.2603 0.0328846 15.4065 0.132277 15.5304L1.28594 16.9075C1.38533 17.0191 1.51542 17.0873 1.67673 17.1123C1.82566 17.1248 1.97458 17.0812 2.12351 16.982L15 6.24492L27.8767 16.982C27.9762 17.0685 28.1062 17.1117 28.2675 17.1117H28.3234C28.4845 17.0872 28.6143 17.0185 28.7142 16.9072L29.868 15.5304C29.9672 15.4062 30.0107 15.2602 29.9978 15.0927C29.985 14.9256 29.9168 14.7923 29.793 14.693Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_328_1966">
        <rect width="30" height="30" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgHomeWhite;
